module.exports = __webpack_public_path__ + "img/avatar1.04be1474.png";